<div class="valign-wrapper">
  @if (!!icon) {
    <mat-icon class="left" [style.color]="iconColor ?? '#9e9e9e'">{{ icon }}</mat-icon>
  }
  @if (showCheckBox) {
    <a
      tabindex="0"
      (click)="onSelectedChange($event)"
      (keydown.enter)="onSelectedChange($event)"
      (keydown.space)="$event.preventDefault(); onSelectedChange($event)">
      <mat-checkbox
        [id]="checkboxId"
        [aria-labelledby]="checkboxLabel"
        [checked]="selected"
        [disabled]="readonly"
        style="margin-right: 1rem" />
    </a>
  }
  <span [id]="checkboxLabel">{{ title }}</span>
</div>
<div>
  @if (showDrilldown) {
    <a
      tabindex="0"
      class="secondary-content grey-text"
      (click)="onDrilldown($event)"
      (keydown.enter)="onDrilldown($event)"
      (keydown.space)="$event.preventDefault(); onDrilldown($event)">
      <mat-icon id="rightChevron" class="align-middle">chevron_right</mat-icon>
    </a>
  }
  @if (editingTemplate || (!templateReadonly && showDeleteButton)) {
    <a
      class="secondary-content as-danger-text"
      (click)="removeSelection()"
      tabindex="0"
      (keydown.enter)="removeSelection()"
      (keydown.space)="$event.preventDefault(); removeSelection()">
      <mat-icon id="clearSelection" class="align-middle">clear</mat-icon>
    </a>
  }
</div>
